export default {
  "title": "EnHome",
  "logo": "https://nerve-meeting.oss-cn-shanghai.aliyuncs.com/enLogo.png",
  "bg": "https://nerve-meeting.oss-cn-shanghai.aliyuncs.com/2026enhome.png",
  "contactBgPC": "https://nerve-meeting.oss-cn-shanghai.aliyuncs.com/enContact.png",
  "schedules": [
    {
      "key": "date-0724",
      "label": "Friday, July 24th, 2026",
      "children": [
        {
          "key": "time-am",
          "label": "Morning 8:00-12:00",
          "children": [
            {
              "key": "f1",
              "theme": "Session 1: Forum for young talents in brain health",
              "location": "Jiuzhou Hall, 5<sup>th</sup> Floor",
              "showExpertList": {
                "Chair": [{
                    "name": "Ying MAO",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yongjun WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Jintai YU",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f2",
              "theme": "Session 2: Forum on public policies and health economic issues",
              "location": "Century Hall, 1<sup>st</sup> Floor",
              "showExpertList": {
                "Chair": [{
                    "name": "Kevin RAO",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Fan WU",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Jing WU",
                    "unit": "",
                    "title": ""
                  }],
                "sExpert": [],
                "expert": []
              },
              "children": [
              ]
            },
            {
              "key": "f3",
              "theme": "Session 3: Research and development of Biomakers in AD: Screening, diagnosis and testing",
              "location": "Yellow River Hall, 3<sup>rd</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Jiong SHI",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Xinyou XIE",
                    "unit": "",
                    "title": ""
                    },
                  {
                    "name": "Wei GUO",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f4",
              "theme": "Session 4: International Brain Care Forum Panel Discussions (8 key topics)",
              "location": "TBD",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Liping LIU",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f5",
              "theme": "Session 5: Brain Health Development: A strategic approach",
              "location": "Meeting Room F, 3<sup>rd</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Yongjun WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Bo WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Zixiao LI",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            }
          ]
        },
        {
          "key": "time-pm",
          "label": "Afternoon 13:30-18:00",
          "children": [
            {
              "key": "f6",
              "theme": "Session 6: Thematic Sessions of the International Brain Care Forum",
              "location": "Yellow River Hall, 3<sup>rd</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Nancy Y. Ip",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yongjun WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Jonathan ROSAND",
                    "unit": "",
                    "title": ""
                  },
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f7",
              "theme": "Session 7: Primary brain health centers and brain health cities",
              "location": "Century Hall, 1<sup>st</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Xiaochun CHEN",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Zixiao LI",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f8",
              "theme": "Session 8: Comprehensive brain health centers",
              "location": "Meeting Room C and D, 3<sup>rd</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Yongjun WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Ying MAO",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yi WANG",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f9",
              "theme": "Session 9: Dialogue between researchers, physicians and brain health industry",
              "location": "Meeting Room C and D, 3<sup>rd</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Zongjiu ZHANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yongjun WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Bai LU",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Bo WANG",
                    "unit": "",
                    "title": ""
                  },
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "",
              "theme": "Brain Health Editorial Board Closed Session",
              "location": "Meeting Room B, 3<sup>rd</sup> Floor",
              "showExpertList": {
                "Chair": [
                   {
                    "name": "Nancy Y. Ip",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Jonathan Rosand",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Wolfgang Grisold",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [
                 
                ],
                "expert": []
              },
              "children": []
            }
          ]
        },
        {
          "key": "time-pm",
          "label": "Evening 19:00-23:00",
          "children": [{
            "key": "",
            "theme": "Speaker Dinner",
            "showExpertList": {
              "Chair": [],
              "sExpert": [],
              "expert": []
            },
            "children": []
          }]
        }
      ]
    },
    {
      "key": "date-0725",
      "label": "Saturday, July 25th, 2026",
      "children": [
        {
          "key": "time-am",
          "label": "Morning 8:00-12:00",
          "children": [
            {
              "key": "",
              "theme": "Plenary session of 2026 Brain Health Conference",
              "location": "Grand-ballroom, 7<sup>th</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                  "name": "Yongjun WANG",
                  "unit": "",
                  "title": ""
                }, {
                  "name": "Ying MAO",
                  "unit": "",
                  "title": ""
                }, {
                  "name": "Yi WANG",
                  "unit": "",
                  "title": ""
                }, {
                  "name": "Min ZHAO",
                  "unit": "",
                  "title": ""
                }, {
                  "name": "Bo WANG",
                  "unit": "",
                  "title": ""
                }, {
                  "name": "Zixiao LI",
                  "unit": "",
                  "title": ""
                }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            }
          ]
        },
        {
          "key": "time-pm",
          "label": "Afternoon 13:00-18:00",
          "children": [
            {
              "key": "f10",
              "theme": "Session 10: Smart brain health with a focus on AI",
              "location": "Jiuzhou Hall, 5<sup>th</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Guoguang ZHAO",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Zongjiu ZHANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yi TANG",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f11",
              "theme": "Session 11: Ecosystem for Management of Alzheimers' disease and dementia",
              "location": "Grand-ballroom, 7<sup>th</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Xiaochun CHEN",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yun XU",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yanjiang WANG",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f12",
              "theme": "Session 12: Brain health for Children",
              "location": "Century Hall, 1<sup>st</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Yi WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Fan JIANG",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f13",
              "theme": "Session 13: Mental and psychological health",
              "location": "Yangtze Hall, 5<sup>th</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Min ZHAO",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Weihua YUE",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f14",
              "theme": "Session 14: Ecosystem for migraine management",
              "location": "Meeting Room B and C, 5<sup>th</sup> Floor",
              "showExpertList": {
                "Chair": [
                   {
                    "name": "Yongjun WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Jinsheng ZENG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Jun LIU",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f15",
              "theme": "Session 15: Emerging technologies in brain health",
              "location": "Pearl Hall, 7<sup>th</sup> Floor",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Ying MAO",
                    "unit": "",
                    "title": ""
                  },{
                    "name": "Nancy Y. Ip",
                    "unit": "",
                    "title": ""
                  },
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            },
            {
              "key": "f16",
              "theme": "Session 16: Brain health and chronic diseases",
              "location": "TBD",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Jian’an WANG",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Yongjun Wang",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Keqin RAO",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Jing WU",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": []
            }
          ]
        }
      ]
    },
    {
      "key": "date-0726",
      "label": "Sunday, July 26th, 2026",
      "children": [
        {
          "key": "time-am",
          "label": "Morning 8:00-12:00",
          "children": [
            {
              "key": "f17",
              "theme": "Session 17: Sleep management",
              "location": "Century Hall, 1<sup>st</sup> Floor",
              "showExpertList": {
                "Chair": [
                   {
                    "name": "Lin LU",
                    "unit": "",
                    "title": ""
                  },
                  {
                    "name": "Min ZHAO",
                    "unit": "",
                    "title": ""
                  },
                ],
                "sExpert": [],
                "expert": []
              },
              "children": [
              ]
            },
            {
              "key": "f18",
              "theme": "Session 18: Lifestyle and food as medicine for brain health",
              "location": "TBD",
              "showExpertList": {
                "Chair": [
                  {
                    "name": "Xiaolin YUE",
                    "unit": "",
                    "title": ""
                  }
                ],
                "sExpert": [],
                "expert": []
              },
              "children": [
              ]
            }
          ]
        }
      ]
    }
  ],
  "contactBgH5": "https://nerve-meeting.oss-cn-shanghai.aliyuncs.com/enContactH5bg.png",
  "contactUS": "AssistantSMIDF@smidf.org.cn",
  "contactUS2": "jiawen.wu@simq.org.cn",
  "programme": {
    "title": "Programme",
    "description": "Agenda of the 2026 Brain Health Conference",
    "Venue": "Shanghai International Convention Center",
    "VenueAddress": "No.2727, Binjiang Avenue, Pudong New District, Shanghai",
    "dataTip": "All schedules are in China Standard Time (Beijing Time, UTC+8)",
    "Note": [
      "Forum 4 and 6 (July 24) - English",
      "Plenary Session (July 25 morning) - Chinese with simultaneous translation",
      "The remaining forums - Chinese (if international guests would like to attend, AI translation will be needed)"
    ]
  },
  "content": "<p style=\"text-align: center;\"><span style=\"font-size: 19px;\"><strong>2026 China Brain Health Conference</strong></span></p><h3 style=\"text-align: start; line-height: 3;\"><span style=\"font-size: 22px;\"><strong>Date:</strong></span></h3><p style=\"text-indent: 2em; text-align: start;\"><span style=\"color: rgb(0, 0, 0);\">July 22-23, the National Brain Health Awareness and Free Medical Consultation Campaign</span></p><p style=\"text-indent: 2em; text-align: start;\"><span style=\"color: rgb(0, 0, 0);\">July 24-26, Brain Health Conference with 18 forums</span></p><h3 style=\"text-align: left; line-height: 3;\"><span style=\"font-size: 22px;\"><strong>Venue:</strong></span></h3><p style=\"text-indent: 2em; text-align: left;\"><span style=\"color: rgb(0, 0, 0);\">Shanghai International Convention Center (No.2727, Binjiang Avenue, Pudong New District, Shanghai)</span></p><p style=\"text-indent: 2em; text-align: left;\"><span style=\"color: rgb(0, 0, 0);\">Brain health has evolved from an academic concept into a global priority</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">and</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">now into a shared mission of action. The Brain Health Conference 2026 brings</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">together policy, practice, innovation, and international collaboration to advance</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">\"Brain Health for All\" across the entire brain health ecosystem.</span></p><h3 style=\"text-align: left; line-height: 3;\"><span style=\"font-size: 22px;\"><strong>Major Highlights</strong></span></h3><p style=\"text-indent: 2em; text-align: left;\"><span style=\"color: rgb(0, 0, 0);\">Global</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">Connectivity</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">—</span><span style=\"color: rgb(0, 0, 0);\">Connecting local</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">innovation with global expertise to</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">advance collaborative solutions for shared brain health challenges</span></p><p style=\"text-indent: 2em; text-align: left;\"><span style=\"color: rgb(0, 0, 0);\">End-to-End Integration</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">—</span><span style=\"color: rgb(0, 0, 0);\">Bridging industry, academia, research, and clinical</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">practice across the full brain health ecosystem-transforming ideas into</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">real-world impact</span></p><p style=\"text-indent: 2em; text-align: left;\"><span style=\"color: rgb(0, 0, 0);\">Clinical</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">&amp; Research Excellence</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">—</span><span style=\"color: rgb(0, 0, 0);\">Bringing together multidisciplinary</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">expertise to address major brain disorders and accelerate progress in</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">diagnosis,</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">treatment,</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">prevention,</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\"> </span><span style=\"color: rgb(0, 0, 0);\">and innovation</span></p><h3 style=\"text-align: left; line-height: 3;\"><span style=\"font-size: 22px;\"><strong>Proposed Organizational Structure of the 2026 Brain Health Congress</strong></span></h3><h4 style=\"text-align: left;\"><strong> </strong><span style=\"font-size: 15px;\"><strong> &nbsp;Supporting Organization:</strong></span></h4><p style=\"text-indent: 2em; text-align: left;\"><span style=\"color: rgb(0, 0, 0);\">National Health Commission of the People's Republic of China</span></p><h4 style=\"text-align: left;\"><span style=\"color: rgb(0, 0, 0);\"> &nbsp; </span><span style=\"font-size: 15px;\"><strong>Host Organizations:</strong></span></h4><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Chinese Medical Association</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">China Brain Health Initiative Expert Committee</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Shanghai Medical Innovation &amp; Development Foundation</span></p><h4 style=\"text-align: left;\"><strong> &nbsp; </strong><span style=\"font-size: 15px;\"><strong>Organizing Institutions: &nbsp;</strong></span></h4><p style=\"text-indent: 2em; text-align: left;\">✦ National Center for Neurological Disorders</p><p style=\"text-indent: 2em; text-align: left;\">✦ National Center for Mental Disorders</p><p style=\"text-indent: 2em; text-align: left;\">✦ National Center for Children's Health</p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">The Hong Kong University of Science and Technology</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">National Center for Chronic and Noncommunicable Disease Control and Prevention, Chinese Center for Disease Control and Prevention.</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Brain Health (International Journal)</span></p><h4 style=\"text-align: left;\"><strong> &nbsp; </strong><span style=\"font-size: 15px;\"><strong>Steering Committee：</strong></span></h4><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Honorary Chairs</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Zhu Chen, Mu-Ming Poo, Li Jin</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Chairs</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Nancy Y. Ip, Jizong Zhao, Liangfu Zhou</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Vice Chairs</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Lin Lu, Xunming Ji, Guang-Zhong Yang, Qun'an Mao, Zongjiu Zhang, Jian Wang</span></p><h4 style=\"text-align: left;\"><strong> &nbsp; </strong><span style=\"font-size: 15px;\"><strong>Congress Organizing Committee：</strong></span></h4><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Chair</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Yongjun Wang</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Executive Chairs</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Ying Mao, Min Zhao, Yi Wang, Bo Wang</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Vice Chairs</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Jianye Wang, Guoguang Zhao, Ying Mao, Lingjiang Li, Keqin Rao, Hongqiang Sun, Qing Guo, Jing Wu</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Expert Committee Members (in order of number of strokes in surnames)</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Lan Ma, Yizheng Wang, Jian Wang, Qun'an Mao, Nancy Y. Ip, Guang-Zhong Yang, Lin Lu, Zongjiu Zhang, Zhu Chen, Lin Chen, Liangfu Zhou, Jizong Zhao, Shumin Duan, Qingming Luo, Xiaosong Gu, Tian-Ming Gao, Heping Cheng, Mu-ming Poo, Li Jin, Xu Zhang, Xunming Ji, Jian'an Wang, Guang Ning, Saijuan Chen, Hefeng Huang, Yigong Shi, Tao Jiang, Xiaoliang Sunney Xie, Keqin Rao, Bai Lu, Hairong Zheng, Qingping Xu, Yumin Zheng</span></p><h4 style=\"text-align: left;\"><strong> &nbsp; </strong><span style=\"font-size: 15px;\"><strong>Congress Secretariat：</strong></span></h4><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Secretary-General</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Zixiao Li</span></p><p style=\"text-indent: 2em; text-align: left;\">✦ <span style=\"color: rgb(0, 0, 0);\">Deputy Secretaries-General</span><span style=\"color: rgb(0, 0, 0); font-family: Verdana;\">: </span><span style=\"color: rgb(0, 0, 0);\">Liang Chen, Xin Fan, Yunjian Zhang</span></p><h3 style=\"text-align: left; line-height: 3;\"><span style=\"font-size: 22px;\"><strong>About the China Brain Health Initiative</strong></span></h3><p style=\"text-indent: 2em; text-align: start;\"><span style=\"color: rgb(0, 0, 0);\">China Brain Health Initiative was jointly launched under the guidance of National Health Commission of the People's Republic of China, by Chinese Society of Neurology, Neurosurgery, Psychiatry and Health Management in Chinese Medical Association, together with several National Medical Centers including Beijing Tiantan Hospital, Shanghai Huashan Hospital, Beijing Xuanwu Hospital, Peking University 6th Hospital, National Center for Chronic and Noncommunicable Disease Control and Prevention, Chinese Center for Disease Control and Prevention, and Shanghai Medical Innovation &amp; Development Foundation in July 2022. Since 2022, CBHI has held its annual conference each July, attracting over 2,000 participants from the brain health field.</span></p>"
}
